module.exports = __webpack_public_path__ + "img/barzahlung.799e9b6.svg";